import { useNavigate, useLocation } from "react-router-dom";
import { useSpace } from "@/hooks/useSpace";
import { MOCK_MEMBERSHIP, MOCK_MODES, MOCK_OFF, PREVIEW_TOOLS } from "@/domain/space";

/**
 * 미리보기 표시 + 가상 소속 바꾸기(?mock=, [실제 소속] = ?mock=off) + 사이드바 색조 켬/끔. 개발 서버에서만 보인다.
 */
export function PreviewNote() {
  if (!PREVIEW_TOOLS) return null;
  return <PreviewNoteBody />;
}

function PreviewNoteBody() {
  const { mockMode, sidebarTint, setSidebarTint } = useSpace();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return (
    <div className="my-preview-note" role="note">
      <span className="badge badge-warn">미리보기 · 가상 데이터</span>
      <span className="my-preview-label">가상 소속</span>
      <div className="my-preview-modes" role="group" aria-label="가상 소속">
        <button
          type="button"
          className={`btn-tiny${mockMode === null ? " is-on" : ""}`}
          aria-pressed={mockMode === null}
          onClick={() => navigate(`${pathname}?mock=${MOCK_OFF}`, { replace: true })}
        >
          실제 소속
        </button>
        {MOCK_MODES.map((m) => (
          <button
            key={m}
            type="button"
            className={`btn-tiny${m === mockMode ? " is-on" : ""}`}
            aria-pressed={m === mockMode}
            onClick={() => navigate(`${pathname}?mock=${m}`, { replace: true })}
          >
            {MOCK_MEMBERSHIP[m].label}
          </button>
        ))}
      </div>
      {/* 사이드바 법인 색조 실험 — 켬/끔 비교용 (법인 칩을 눌러 법인 공간에서 확인) */}
      <span className="my-preview-label">사이드바 색조</span>
      <div className="my-preview-modes" role="group" aria-label="사이드바 색조">
        {([true, false] as const).map((on) => (
          <button
            key={String(on)}
            type="button"
            className={`btn-tiny${sidebarTint === on ? " is-on" : ""}`}
            aria-pressed={sidebarTint === on}
            onClick={() => setSidebarTint(on)}
          >
            {on ? "켬" : "끔"}
          </button>
        ))}
      </div>
    </div>
  );
}
